import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { CWTypeScript } from "../../shared/utilty/js-actions/CWTypeScript";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ICatiGesOnSurecler_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ICatiGesOnSurecler_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GET_ON_SUREC_OZET_GETIR: any[];
  GET_ON_SUREC_OZET_GETIR_dummy: any[];
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  AktifSirketGetir: any[];
  AktifSirketGetir_dummy: any[];
  GET_SATIS_TEMSILCISI: any[];
  GET_SATIS_TEMSILCISI_dummy: any[];
  GetProjeAsamalari: any[];
  GetProjeAsamalari_dummy: any[];
  GET_PROJE_ON_SUREC: any[];
  GET_PROJE_ON_SUREC_dummy: any[];
  GET_NETSIS_STOK_LISTESI: any[];
  GET_NETSIS_STOK_LISTESI_dummy: any[];
  CATI_GES_ON_KESIF_GETIR: any[];
  CATI_GES_ON_KESIF_GETIR_dummy: any[];
  PROJE_DOSYLARI_GETIR: any[];
  PROJE_DOSYLARI_GETIR_dummy: any[];
  DosyalariDBdenYukle: any[];
  DosyalariDBdenYukle_dummy: any[];
  DosyalariGetir: any[];
  DosyalariGetir_dummy: any[];
  ON_KESIF_KALEMLER_GETIR: any[];
  ON_KESIF_KALEMLER_GETIR_dummy: any[];
  KalemleriDBdenYukle: any[];
  KalemleriDBdenYukle_dummy: any[];
  KalemleriGetir: any[];
  KalemleriGetir_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  KalemSil: any[];
  KalemSil_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  Multiply: number;
  Multiply_dummy: number;
  KalemEkle: any[];
  KalemEkle_dummy: any[];
  UploadFile: any[];
  UploadFile_dummy: any[];
  DosyaEkle: any[];
  DosyaEkle_dummy: any[];
  ForEach4: UploadFileResponse;
  ForEach4_dummy: UploadFileResponse;
  DownloadFile: any;
  DownloadFile_dummy: any;
  DosyaSil: any[];
  DosyaSil_dummy: any[];
  KESIF_CATI_KAYDET: any[];
  KESIF_CATI_KAYDET_dummy: any[];
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  KaydetHazirla: string;
  KaydetHazirla_dummy: string;
  ON_KESIF_KALEMLER_TOPLU_KAYDET: any[];
  ON_KESIF_KALEMLER_TOPLU_KAYDET_dummy: any[];
  DosyalariKaydetHazirla: string;
  DosyalariKaydetHazirla_dummy: string;
  TopluDosyaKaydet: any[];
  TopluDosyaKaydet_dummy: any[];
  OnayDurumuKontrol: any[];
  OnayDurumuKontrol_dummy: any[];
  PROFORMA_GENEL_BILGILERI_GETIR: any[];
  PROFORMA_GENEL_BILGILERI_GETIR_dummy: any[];
  PROFORMA_KALEMLERI_GETIR: any[];
  PROFORMA_KALEMLERI_GETIR_dummy: any[];
  ForEach5: UploadFileResponse;
  ForEach5_dummy: UploadFileResponse;
  ON_KESIF_PROFORMA_KAYDET: any[];
  ON_KESIF_PROFORMA_KAYDET_dummy: any[];
  KESIF_ONAY: any[];
  KESIF_ONAY_dummy: any[];
  NET_KESIF_CATI_GETIR: any[];
  NET_KESIF_CATI_GETIR_dummy: any[];
  GET_PROJEYONETICI_USERS: any[];
  GET_PROJEYONETICI_USERS_dummy: any[];
  ForEach6: UploadFileResponse;
  ForEach6_dummy: UploadFileResponse;
  ON_SUREC_PM_GERI_AL: any[];
  ON_SUREC_PM_GERI_AL_dummy: any[];
  ON_SUREC_PM_ONAYLA: any[];
  ON_SUREC_PM_ONAYLA_dummy: any[];
  ON_SUREC_UY_ONAY_GERIAL: any[];
  ON_SUREC_UY_ONAY_GERIAL_dummy: any[];
  ON_SUREC_UY_ONAYLA: any[];
  ON_SUREC_UY_ONAYLA_dummy: any[];
  isComp930685Visible: "visible" | "hidden";
  isComp200548Visible: "visible" | "hidden";
  isComp38139Visible: "visible" | "hidden";
  isComp230193Visible: "visible" | "hidden";
  isComp108416Visible: "visible" | "hidden";
  isComp167824Visible: "visible" | "hidden";
  isComp995070Visible: "visible" | "hidden";
  isComp606562Visible: "visible" | "hidden";
  isComp777039Visible: "visible" | "hidden";
  isComp682157Visible: "visible" | "hidden";
  isComp457735Visible: "visible" | "hidden";
  isComp615511Visible: "visible" | "hidden";
  isComp340168Visible: "visible" | "hidden";
  isComp843199Visible: "visible" | "hidden";
  isComp825089Visible: "visible" | "hidden";
  isComp340333Visible: "visible" | "hidden";
  isComp589579Visible: "visible" | "hidden";
  isComp278838Visible: "visible" | "hidden";
  isComp788639Visible: "visible" | "hidden";
  isComp557821Visible: "visible" | "hidden";
  isComp171830Visible: "visible" | "hidden";
  isComp485928Visible: "visible" | "hidden";
  isComp429832Visible: "visible" | "hidden";
  isComp384588Visible: "visible" | "hidden";
  isComp814465Visible: "visible" | "hidden";
  isComp831693Visible: "visible" | "hidden";
  isComp551404Visible: "visible" | "hidden";
  isComp687126Visible: "visible" | "hidden";
  isComp52540Visible: "visible" | "hidden";
  isComp647527Visible: "visible" | "hidden";
  isComp371141Visible: "visible" | "hidden";
  isComp583734Visible: "visible" | "hidden";
  isComp3461Visible: "visible" | "hidden";
  isComp848368Visible: "visible" | "hidden";
  isComp135945Visible: "visible" | "hidden";
  isComp289590Visible: "visible" | "hidden";
  isComp432583Visible: "visible" | "hidden";
  isComp781192Visible: "visible" | "hidden";
  isComp465589Visible: "visible" | "hidden";
  isComp848477Visible: "visible" | "hidden";
  isComp500544Visible: "visible" | "hidden";
  isComp233488Visible: "visible" | "hidden";
  isComp320489Visible: "visible" | "hidden";
  isComp480487Enabled: "enabled" | "disabled";
  isComp353063Enabled: "enabled" | "disabled";
  isComp570640Enabled: "enabled" | "disabled";
  isComp658487Enabled: "enabled" | "disabled";
  isComp641491Enabled: "enabled" | "disabled";
  isComp864664Enabled: "enabled" | "disabled";
  isComp180639Enabled: "enabled" | "disabled";
  isComp153946Enabled: "enabled" | "disabled";
  isComp596085Enabled: "enabled" | "disabled";
  isComp123507Enabled: "enabled" | "disabled";
  isCompcatigesonsurecler_261399AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_367991AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_832682AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_648652AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_899938AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_442005AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_494735AuthorizationVisible: "visible" | "hidden";
  isCompcatigesonsurecler_135945AuthorizationVisible: "visible" | "hidden";
}

export class CatiGesOnSurecler_ScreenBase extends React.PureComponent<
  ICatiGesOnSurecler_ScreenProps,
  any
> {
  catigesonsurecler_913183_value_kuikaDateRef: React.RefObject<any>;
  catigesonsurecler_662082_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_707377_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_166467_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_380385_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_681014_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_478263_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_393036_value_kuikaAutoCompleteRef: React.RefObject<any>;
  catigesonsurecler_801362_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_899735_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_266261_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_990822_value_kuikaDateRef: React.RefObject<any>;
  catigesonsurecler_864033_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_569086_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_940300_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_775375_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_868333_value_kuikaSelectBoxRef: React.RefObject<any>;
  catigesonsurecler_944389_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_600320_value_kuikaAutoCompleteRef: React.RefObject<any>;
  catigesonsurecler_775136_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_467193_value_kuikaTableRef: React.RefObject<any>;
  catigesonsurecler_594487_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "08e1cb20-24ad-e190-d46b-beded98dd4ae",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4106607f-9ae3-47ff-8d8a-3ced44ab92c6",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "04f35467-f0c1-4617-be55-656ead7d9a52",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 547809, PropertyName: "value", Value: "·" },
        { Id: 114330, PropertyName: "value", Value: "- Proje Detayları" },
        { Id: 19253, PropertyName: "value", Value: "|" },
        { Id: 551015, PropertyName: "value", Value: "|" },
        { Id: 321188, PropertyName: "value", Value: "→" },
        { Id: 490554, PropertyName: "tab", Value: "📋 Özet" },
        { Id: 370812, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 873090, PropertyName: "value", Value: "Kategori:" },
        { Id: 707335, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 692080, PropertyName: "value", Value: "Müşteri:" },
        { Id: 756078, PropertyName: "value", Value: "İletişim:" },
        { Id: 300522, PropertyName: "value", Value: "Telefon:" },
        { Id: 652581, PropertyName: "value", Value: "ÖN SÜRECİN ÖZETİ" },
        { Id: 695712, PropertyName: "value", Value: "Ön Keşif:" },
        { Id: 189120, PropertyName: "value", Value: "-" },
        { Id: 682190, PropertyName: "value", Value: "Bekliyor" },
        { Id: 942475, PropertyName: "value", Value: "Proforma:" },
        { Id: 125778, PropertyName: "value", Value: "-" },
        { Id: 50774, PropertyName: "value", Value: "Bekliyor" },
        { Id: 569873, PropertyName: "value", Value: "Net Keşif:" },
        { Id: 398768, PropertyName: "value", Value: "-" },
        { Id: 245857, PropertyName: "value", Value: "Bekliyor" },
        { Id: 66815, PropertyName: "value", Value: "PM Onayı:" },
        { Id: 501661, PropertyName: "value", Value: "-" },
        { Id: 928750, PropertyName: "value", Value: "Bekliyor" },
        { Id: 954260, PropertyName: "value", Value: "Yönetim:" },
        { Id: 964154, PropertyName: "value", Value: "-" },
        { Id: 311614, PropertyName: "value", Value: "Bekliyor" },
        { Id: 644014, PropertyName: "value", Value: "KEŞİF TEKNİK ÖZET" },
        { Id: 921297, PropertyName: "value", Value: "kWp Güç" },
        { Id: 892535, PropertyName: "value", Value: "m² Alan" },
        { Id: 210361, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 416312, PropertyName: "value", Value: "Tahmini Maliyet" },
        { Id: 367991, PropertyName: "tab", Value: "🔍 Ön Keşif" },
        { Id: 503808, PropertyName: "value", Value: "📋 Genel Bilgiler" },
        { Id: 440869, PropertyName: "value", Value: "Keşif Tarihi" },
        { Id: 913183, PropertyName: "placeholder", Value: "Tarih Seçin..." },
        { Id: 906806, PropertyName: "value", Value: "Kullanıcı Seçiniz" },
        {
          Id: 662082,
          PropertyName: "placeholder",
          Value: "Kullanıcı Seçiniz ...",
        },
        { Id: 824192, PropertyName: "value", Value: "Ada / Parsel" },
        { Id: 203346, PropertyName: "placeholder", Value: "Ada / Parsel" },
        {
          Id: 319997,
          PropertyName: "value",
          Value: "⚡ Teknik Altyapı ve Elektrik",
        },
        { Id: 813625, PropertyName: "value", Value: "Sözleşme Gücü (kW)" },
        { Id: 14467, PropertyName: "placeholder", Value: "Sözleşme Gücü (kW)" },
        { Id: 588963, PropertyName: "value", Value: "Abone Tipi" },
        { Id: 707377, PropertyName: "placeholder", Value: "Abone Tipi" },
        { Id: 716896, PropertyName: "value", Value: "Trafo Gücü (kVA)" },
        { Id: 766200, PropertyName: "placeholder", Value: "Trafo Gücü (kVA)" },
        { Id: 398710, PropertyName: "value", Value: "Ana Şalter Akımı (A)" },
        {
          Id: 145387,
          PropertyName: "placeholder",
          Value: "Ana Şalter Akımı (A)",
        },
        { Id: 152274, PropertyName: "value", Value: "Pano Mesafesi (m)" },
        { Id: 743336, PropertyName: "placeholder", Value: "Pano Mesafesi (m)" },
        {
          Id: 340500,
          PropertyName: "value",
          Value: "🏗 Çatı Yapısal Özellikleri",
        },
        { Id: 66394, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 166467, PropertyName: "placeholder", Value: "Çatı Tipi" },
        { Id: 333518, PropertyName: "value", Value: "Eğim (°)" },
        { Id: 724523, PropertyName: "placeholder", Value: "Eğim (°)" },
        { Id: 287977, PropertyName: "value", Value: "Yön" },
        { Id: 380385, PropertyName: "placeholder", Value: "Çatı Yönü" },
        {
          Id: 595525,
          PropertyName: "value",
          Value: "Kullanılabilir Alan (m²)",
        },
        {
          Id: 886075,
          PropertyName: "placeholder",
          Value: "Kullanılabilir Alan (m²)",
        },
        { Id: 386476, PropertyName: "value", Value: "Tahmini Güç (kWp)" },
        { Id: 950845, PropertyName: "placeholder", Value: "Tahmini Güç (kWp)" },
        {
          Id: 517137,
          PropertyName: "value",
          Value: "Toplam Kullanılabilir Alan",
        },
        {
          Id: 323299,
          PropertyName: "placeholder",
          Value: "Toplam Kullanılabilir Alan ",
        },
        { Id: 971603, PropertyName: "value", Value: "Gölgeleme durumu" },
        { Id: 246942, PropertyName: "placeholder", Value: "Gölgeleme durumu" },
        { Id: 536916, PropertyName: "value", Value: "Çatı Taşıyıcı Sistemi" },
        { Id: 442969, PropertyName: "value", Value: "Çatı Taşıyıcı Sistemi:" },
        {
          Id: 681014,
          PropertyName: "placeholder",
          Value: "Çatı Taşıyıcı Sistemi",
        },
        { Id: 763866, PropertyName: "value", Value: "Hadve  Aralıkları" },
        { Id: 585296, PropertyName: "placeholder", Value: "Hadve  Aralıkları" },
        { Id: 763120, PropertyName: "value", Value: "Kaplama Durumu" },
        { Id: 629508, PropertyName: "placeholder", Value: "Kaplama Durumu" },
        { Id: 927333, PropertyName: "value", Value: "🚛 Lojistik" },
        { Id: 893765, PropertyName: "value", Value: "Vinç Kurulum Alanı" },
        {
          Id: 946973,
          PropertyName: "placeholder",
          Value: "Vinç Kurulum Alanı",
        },
        { Id: 185287, PropertyName: "value", Value: "İnverter Montaj Yeri" },
        {
          Id: 394531,
          PropertyName: "placeholder",
          Value: "İnverter Montaj Yeri",
        },
        { Id: 621953, PropertyName: "value", Value: "Kablo Yolu" },
        { Id: 397937, PropertyName: "placeholder", Value: "Kablo Yolu" },
        { Id: 777770, PropertyName: "value", Value: "📦 Malzeme Kalemleri" },
        { Id: 686210, PropertyName: "title", Value: "Title" },
        { Id: 796619, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 43044, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 717414, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 976519, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 183286, PropertyName: "value", Value: "[datafield:satırtoplam]" },
        { Id: 611509, PropertyName: "value", Value: "Stok Seçiniz" },
        { Id: 393036, PropertyName: "placeholder", Value: "Stok Seçiniz..." },
        { Id: 335749, PropertyName: "value", Value: "Miktar Giriniz" },
        { Id: 207266, PropertyName: "placeholder", Value: "Miktar Giriniz" },
        { Id: 345017, PropertyName: "value", Value: "Birim" },
        { Id: 480487, PropertyName: "placeholder", Value: "Kablo Yolu" },
        { Id: 464718, PropertyName: "value", Value: "Fiyat" },
        { Id: 542792, PropertyName: "value", Value: "Toplam Fiyat" },
        { Id: 570640, PropertyName: "placeholder", Value: "Miktar Giriniz" },
        { Id: 740127, PropertyName: "label", Value: "Ekle" },
        { Id: 282201, PropertyName: "value", Value: "📝 Açıklamalar" },
        { Id: 581913, PropertyName: "value", Value: "Açıklama 1" },
        {
          Id: 225026,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 36234, PropertyName: "value", Value: "Açıklama 2" },
        {
          Id: 26200,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 141893, PropertyName: "value", Value: "Açıklama 3" },
        {
          Id: 122352,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 673720, PropertyName: "value", Value: "📎 Dosyalar" },
        { Id: 923782, PropertyName: "value", Value: "Mevcut Dosyalar" },
        { Id: 261776, PropertyName: "label", Value: "Dosya Seç" },
        { Id: 850690, PropertyName: "title", Value: "Title" },
        { Id: 650738, PropertyName: "value", Value: "[datafield:dosyaadi]" },
        {
          Id: 338419,
          PropertyName: "value",
          Value: "💰 Ön Keşif Tahmini Maliyet",
        },
        { Id: 970414, PropertyName: "label", Value: "Kaydet" },
        { Id: 832682, PropertyName: "tab", Value: "📄 Proforma" },
        { Id: 948923, PropertyName: "value", Value: "Proje Kalemleri" },
        { Id: 886731, PropertyName: "value", Value: "Fİş No" },
        { Id: 694168, PropertyName: "value", Value: "Stok Kodu" },
        { Id: 33629, PropertyName: "value", Value: "Stok Adı" },
        { Id: 124075, PropertyName: "value", Value: "Miktar" },
        { Id: 734770, PropertyName: "value", Value: "DovFiyat" },
        { Id: 94301, PropertyName: "value", Value: "Para Birimi" },
        { Id: 996647, PropertyName: "value", Value: "Net Fiyat" },
        { Id: 414859, PropertyName: "value", Value: "İskonto 1" },
        { Id: 839311, PropertyName: "value", Value: "İskonto2" },
        { Id: 273002, PropertyName: "value", Value: "DovTutar" },
        { Id: 545201, PropertyName: "title", Value: "Title" },
        { Id: 226022, PropertyName: "value", Value: "[datafield:fisno]" },
        { Id: 67710, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 376378, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 95308, PropertyName: "value", Value: "[datafield:sthar_gcmik]" },
        {
          Id: 465686,
          PropertyName: "value",
          Value: "[datafield:sthar_dovfiat]",
        },
        { Id: 825226, PropertyName: "value", Value: "[datafield:para_birimi]" },
        { Id: 836649, PropertyName: "value", Value: "[datafield:sthar_nf]" },
        { Id: 276199, PropertyName: "value", Value: "[datafield:isk1]" },
        { Id: 254824, PropertyName: "value", Value: "[datafield:isk2]" },
        { Id: 885723, PropertyName: "value", Value: "[datafield:doviztut]" },
        { Id: 752985, PropertyName: "value", Value: "💰 Net Keşif Maliyet" },
        { Id: 927461, PropertyName: "value", Value: "📎 Dosyalar" },
        { Id: 194557, PropertyName: "value", Value: "Mevcut Dosyalar" },
        { Id: 410008, PropertyName: "label", Value: "Dosya Seç" },
        { Id: 319112, PropertyName: "title", Value: "Title" },
        { Id: 172441, PropertyName: "value", Value: "[datafield:dosyaadi]" },
        { Id: 673242, PropertyName: "value", Value: "📋 Genel Bilgiler" },
        { Id: 700575, PropertyName: "value", Value: "Proforma Tutar" },
        { Id: 95182, PropertyName: "value", Value: "Proforma Notu" },
        { Id: 169821, PropertyName: "placeholder", Value: "Proforma Notu" },
        { Id: 641491, PropertyName: "label", Value: "Kaydet" },
        { Id: 972066, PropertyName: "value", Value: "Proje Süreci Onayı" },
        {
          Id: 31452,
          PropertyName: "value",
          Value:
            "Projenin hesaplanan maliyet-satış dengesi, belirlenen kar hedefinin (%20) altında kalmaktadır. Sürecin devam edebilmesi için yönetici onayı gerekmektedir.",
        },
        { Id: 237140, PropertyName: "label", Value: "Onayla" },
        { Id: 417687, PropertyName: "label", Value: "İptal Et" },
        { Id: 899938, PropertyName: "tab", Value: "📐 Net Keşif" },
        { Id: 640220, PropertyName: "value", Value: "📋 Genel Bilgiler" },
        { Id: 589859, PropertyName: "value", Value: "Keşif Tarihi" },
        { Id: 990822, PropertyName: "placeholder", Value: "Tarih Seçin..." },
        { Id: 359978, PropertyName: "value", Value: "Kullanıcı Seçiniz" },
        {
          Id: 864033,
          PropertyName: "placeholder",
          Value: "Kullanıcı Seçiniz ...",
        },
        { Id: 143152, PropertyName: "value", Value: "Ada / Parsel" },
        { Id: 784281, PropertyName: "placeholder", Value: "Ada / Parsel" },
        {
          Id: 896075,
          PropertyName: "value",
          Value: "⚡ Teknik Altyapı ve Elektrik",
        },
        { Id: 717848, PropertyName: "value", Value: "Sözleşme Gücü (kW)" },
        {
          Id: 798603,
          PropertyName: "placeholder",
          Value: "Sözleşme Gücü (kW)",
        },
        { Id: 248620, PropertyName: "value", Value: "Abone Tipi" },
        { Id: 569086, PropertyName: "placeholder", Value: "Abone Tipi" },
        { Id: 946381, PropertyName: "value", Value: "Trafo Gücü (kVA)" },
        { Id: 865048, PropertyName: "placeholder", Value: "Trafo Gücü (kVA)" },
        { Id: 473868, PropertyName: "value", Value: "Ana Şalter Akımı (A)" },
        {
          Id: 907314,
          PropertyName: "placeholder",
          Value: "Ana Şalter Akımı (A)",
        },
        { Id: 456763, PropertyName: "value", Value: "Pano Mesafesi (m)" },
        { Id: 320637, PropertyName: "placeholder", Value: "Pano Mesafesi (m)" },
        {
          Id: 77246,
          PropertyName: "value",
          Value: "🏗 Çatı Yapısal Özellikleri",
        },
        { Id: 941542, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 940300, PropertyName: "placeholder", Value: "Çatı Tipi" },
        { Id: 990724, PropertyName: "value", Value: "Eğim (°)" },
        { Id: 967785, PropertyName: "placeholder", Value: "Eğim (°)" },
        { Id: 573951, PropertyName: "value", Value: "Yön" },
        { Id: 775375, PropertyName: "placeholder", Value: "Çatı Yönü" },
        {
          Id: 925707,
          PropertyName: "value",
          Value: "Kullanılabilir Alan (m²)",
        },
        {
          Id: 257886,
          PropertyName: "placeholder",
          Value: "Kullanılabilir Alan (m²)",
        },
        { Id: 10747, PropertyName: "value", Value: "Tahmini Güç (kWp)" },
        { Id: 672009, PropertyName: "placeholder", Value: "Tahmini Güç (kWp)" },
        {
          Id: 312596,
          PropertyName: "value",
          Value: "Toplam Kullanılabilir Alan",
        },
        {
          Id: 235750,
          PropertyName: "placeholder",
          Value: "Toplam Kullanılabilir Alan ",
        },
        { Id: 975867, PropertyName: "value", Value: "Gölgeleme durumu" },
        { Id: 568262, PropertyName: "placeholder", Value: "Gölgeleme durumu" },
        { Id: 830446, PropertyName: "value", Value: "Çatı Taşıyıcı Sistemi" },
        { Id: 829156, PropertyName: "value", Value: "Çatı Taşıyıcı Sistemi:" },
        {
          Id: 868333,
          PropertyName: "placeholder",
          Value: "Çatı Taşıyıcı Sistemi",
        },
        { Id: 343939, PropertyName: "value", Value: "Hadve  Aralıkları" },
        { Id: 219090, PropertyName: "placeholder", Value: "Hadve  Aralıkları" },
        { Id: 128675, PropertyName: "value", Value: "Kaplama Durumu" },
        { Id: 328449, PropertyName: "placeholder", Value: "Kaplama Durumu" },
        { Id: 118669, PropertyName: "value", Value: "🚛 Lojistik" },
        { Id: 448593, PropertyName: "value", Value: "Vinç Kurulum Alanı" },
        { Id: 4244, PropertyName: "placeholder", Value: "Vinç Kurulum Alanı" },
        { Id: 402963, PropertyName: "value", Value: "İnverter Montaj Yeri" },
        {
          Id: 494854,
          PropertyName: "placeholder",
          Value: "İnverter Montaj Yeri",
        },
        { Id: 896889, PropertyName: "value", Value: "Kablo Yolu" },
        { Id: 592482, PropertyName: "placeholder", Value: "Kablo Yolu" },
        { Id: 383525, PropertyName: "value", Value: "📦 Malzeme Kalemleri" },
        { Id: 264526, PropertyName: "title", Value: "Title" },
        { Id: 463396, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 517175, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 6372, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 511664, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 396373, PropertyName: "value", Value: "[datafield:satırtoplam]" },
        { Id: 252830, PropertyName: "value", Value: "Stok Seçiniz" },
        { Id: 600320, PropertyName: "placeholder", Value: "Stok Seçiniz..." },
        { Id: 605417, PropertyName: "value", Value: "Miktar Giriniz" },
        { Id: 102756, PropertyName: "placeholder", Value: "Miktar Giriniz" },
        { Id: 328532, PropertyName: "value", Value: "Birim" },
        { Id: 372323, PropertyName: "placeholder", Value: "Kablo Yolu" },
        { Id: 549833, PropertyName: "value", Value: "Fiyat" },
        { Id: 101095, PropertyName: "value", Value: "Toplam Fiyat" },
        { Id: 153946, PropertyName: "placeholder", Value: "Miktar Giriniz" },
        { Id: 978224, PropertyName: "label", Value: "Ekle" },
        { Id: 803496, PropertyName: "value", Value: "📝 Açıklamalar" },
        { Id: 471386, PropertyName: "value", Value: "Açıklama 1" },
        {
          Id: 490847,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 731438, PropertyName: "value", Value: "Açıklama 2" },
        {
          Id: 668639,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 586255, PropertyName: "value", Value: "Açıklama 3" },
        {
          Id: 91916,
          PropertyName: "placeholder",
          Value: "İyi durumda, ek güçlendirme gerekmez.",
        },
        { Id: 268525, PropertyName: "value", Value: "📎 Dosyalar" },
        { Id: 885261, PropertyName: "value", Value: "Mevcut Dosyalar" },
        { Id: 414931, PropertyName: "label", Value: "Dosya Seç" },
        { Id: 141187, PropertyName: "title", Value: "Title" },
        { Id: 735119, PropertyName: "value", Value: "[datafield:dosyaadi]" },
        {
          Id: 639072,
          PropertyName: "value",
          Value: "💰 Net Keşif Tahmini Maliyet",
        },
        { Id: 596085, PropertyName: "label", Value: "Kaydet" },
        { Id: 442005, PropertyName: "tab", Value: "👔 PY Onayı" },
        { Id: 492374, PropertyName: "value", Value: "Proje Kalemleri" },
        { Id: 761485, PropertyName: "value", Value: "Fİş No" },
        { Id: 503052, PropertyName: "value", Value: "Stok Kodu" },
        { Id: 923873, PropertyName: "value", Value: "Stok Adı" },
        { Id: 727190, PropertyName: "value", Value: "Miktar" },
        { Id: 927767, PropertyName: "value", Value: "DovFiyat" },
        { Id: 361335, PropertyName: "value", Value: "Para Birimi" },
        { Id: 108137, PropertyName: "value", Value: "Net Fiyat" },
        { Id: 252489, PropertyName: "value", Value: "İskonto 1" },
        { Id: 68685, PropertyName: "value", Value: "İskonto2" },
        { Id: 91880, PropertyName: "value", Value: "DovTutar" },
        { Id: 546814, PropertyName: "title", Value: "Title" },
        { Id: 217098, PropertyName: "value", Value: "[datafield:fisno]" },
        { Id: 485116, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 267925, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 249797, PropertyName: "value", Value: "[datafield:sthar_gcmik]" },
        {
          Id: 748643,
          PropertyName: "value",
          Value: "[datafield:sthar_dovfiat]",
        },
        { Id: 481954, PropertyName: "value", Value: "[datafield:para_birimi]" },
        { Id: 541041, PropertyName: "value", Value: "[datafield:sthar_nf]" },
        { Id: 855537, PropertyName: "value", Value: "[datafield:isk1]" },
        { Id: 812402, PropertyName: "value", Value: "[datafield:isk2]" },
        { Id: 92500, PropertyName: "value", Value: "[datafield:doviztut]" },
        { Id: 117363, PropertyName: "value", Value: "💰 Net Keşif Maliyet" },
        { Id: 377392, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 36005, PropertyName: "value", Value: "Kategori:" },
        { Id: 467975, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 343483, PropertyName: "value", Value: "Müşteri:" },
        { Id: 390610, PropertyName: "value", Value: "İletişim:" },
        { Id: 391696, PropertyName: "value", Value: "Telefon:" },
        { Id: 359594, PropertyName: "value", Value: "ÖN SÜRECİN ÖZETİ" },
        { Id: 724741, PropertyName: "value", Value: "Ön Keşif:" },
        { Id: 769315, PropertyName: "value", Value: "-" },
        { Id: 283877, PropertyName: "value", Value: "Bekliyor" },
        { Id: 697210, PropertyName: "value", Value: "Proforma:" },
        { Id: 979155, PropertyName: "value", Value: "-" },
        { Id: 904529, PropertyName: "value", Value: "Bekliyor" },
        { Id: 653453, PropertyName: "value", Value: "Net Keşif:" },
        { Id: 785953, PropertyName: "value", Value: "-" },
        { Id: 789758, PropertyName: "value", Value: "Bekliyor" },
        { Id: 115413, PropertyName: "value", Value: "PM Onayı:" },
        { Id: 265953, PropertyName: "value", Value: "-" },
        { Id: 478901, PropertyName: "value", Value: "Bekliyor" },
        { Id: 893975, PropertyName: "value", Value: "Yönetim:" },
        { Id: 536017, PropertyName: "value", Value: "-" },
        { Id: 286761, PropertyName: "value", Value: "Bekliyor" },
        { Id: 523429, PropertyName: "value", Value: "KEŞİF TEKNİK ÖZET" },
        { Id: 242331, PropertyName: "value", Value: "kWp Güç" },
        { Id: 874933, PropertyName: "value", Value: "m² Alan" },
        { Id: 456282, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 813761, PropertyName: "value", Value: "Tahmini Maliyet" },
        { Id: 477730, PropertyName: "value", Value: "Onay Notu" },
        {
          Id: 858665,
          PropertyName: "placeholder",
          Value: "Onay Notu Yazınız...",
        },
        { Id: 551404, PropertyName: "label", Value: "Onayı geri al" },
        { Id: 549129, PropertyName: "label", Value: "Reddet" },
        { Id: 687126, PropertyName: "label", Value: "Onayla" },
        { Id: 494735, PropertyName: "tab", Value: "👑 Yönetim Onayı" },
        { Id: 251668, PropertyName: "value", Value: "Proje Kalemleri" },
        { Id: 373424, PropertyName: "value", Value: "Fİş No" },
        { Id: 950849, PropertyName: "value", Value: "Stok Kodu" },
        { Id: 741548, PropertyName: "value", Value: "Stok Adı" },
        { Id: 304412, PropertyName: "value", Value: "Miktar" },
        { Id: 954891, PropertyName: "value", Value: "DovFiyat" },
        { Id: 801928, PropertyName: "value", Value: "Para Birimi" },
        { Id: 530484, PropertyName: "value", Value: "Net Fiyat" },
        { Id: 984005, PropertyName: "value", Value: "İskonto 1" },
        { Id: 81596, PropertyName: "value", Value: "İskonto2" },
        { Id: 473022, PropertyName: "value", Value: "DovTutar" },
        { Id: 617573, PropertyName: "title", Value: "Title" },
        { Id: 825120, PropertyName: "value", Value: "[datafield:fisno]" },
        { Id: 998092, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 858542, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 307074, PropertyName: "value", Value: "[datafield:sthar_gcmik]" },
        {
          Id: 218303,
          PropertyName: "value",
          Value: "[datafield:sthar_dovfiat]",
        },
        { Id: 67970, PropertyName: "value", Value: "[datafield:para_birimi]" },
        { Id: 276392, PropertyName: "value", Value: "[datafield:sthar_nf]" },
        { Id: 624021, PropertyName: "value", Value: "[datafield:isk1]" },
        { Id: 152259, PropertyName: "value", Value: "[datafield:isk2]" },
        { Id: 536887, PropertyName: "value", Value: "[datafield:doviztut]" },
        { Id: 74803, PropertyName: "value", Value: "💰 Net Keşif Maliyet" },
        { Id: 27727, PropertyName: "value", Value: "PROJE BİLGİLERİ" },
        { Id: 774444, PropertyName: "value", Value: "Kategori:" },
        { Id: 407484, PropertyName: "value", Value: "Netsis Kodu:" },
        { Id: 742812, PropertyName: "value", Value: "Müşteri:" },
        { Id: 838137, PropertyName: "value", Value: "İletişim:" },
        { Id: 205169, PropertyName: "value", Value: "Telefon:" },
        { Id: 130983, PropertyName: "value", Value: "ÖN SÜRECİN ÖZETİ" },
        { Id: 947754, PropertyName: "value", Value: "Ön Keşif:" },
        { Id: 123188, PropertyName: "value", Value: "-" },
        { Id: 808976, PropertyName: "value", Value: "Bekliyor" },
        { Id: 947009, PropertyName: "value", Value: "Proforma:" },
        { Id: 586632, PropertyName: "value", Value: "-" },
        { Id: 202005, PropertyName: "value", Value: "Bekliyor" },
        { Id: 81396, PropertyName: "value", Value: "Net Keşif:" },
        { Id: 720867, PropertyName: "value", Value: "-" },
        { Id: 870616, PropertyName: "value", Value: "Bekliyor" },
        { Id: 526165, PropertyName: "value", Value: "PM Onayı:" },
        { Id: 632457, PropertyName: "value", Value: "-" },
        { Id: 994923, PropertyName: "value", Value: "Bekliyor" },
        { Id: 642939, PropertyName: "value", Value: "Yönetim:" },
        { Id: 563960, PropertyName: "value", Value: "-" },
        { Id: 285720, PropertyName: "value", Value: "Bekliyor" },
        { Id: 317578, PropertyName: "value", Value: "KEŞİF TEKNİK ÖZET" },
        { Id: 501317, PropertyName: "value", Value: "kWp Güç" },
        { Id: 585488, PropertyName: "value", Value: "m² Alan" },
        { Id: 172700, PropertyName: "value", Value: "Çatı Tipi" },
        { Id: 290895, PropertyName: "value", Value: "Tahmini Maliyet" },
        { Id: 87740, PropertyName: "value", Value: "Onay Notu" },
        {
          Id: 961677,
          PropertyName: "placeholder",
          Value: "Onay Notu Yazınız...",
        },
        { Id: 233488, PropertyName: "label", Value: "Onayı geri al" },
        { Id: 320489, PropertyName: "label", Value: "Onayla" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach4: any[];
  ForEach5: any[];
  ForEach6: any[];

  constructor(props) {
    super(props);
    this.catigesonsurecler_913183_value_kuikaDateRef = React.createRef();
    this.catigesonsurecler_662082_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_203346_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_707377_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_166467_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_380385_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_681014_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_585296_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_629508_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_946973_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_394531_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_397937_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_478263_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_393036_value_kuikaAutoCompleteRef =
      React.createRef();
    this.catigesonsurecler_480487_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_801362_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_899735_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_266261_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_990822_value_kuikaDateRef = React.createRef();
    this.catigesonsurecler_864033_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_784281_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_569086_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_940300_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_775375_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_868333_value_kuikaSelectBoxRef = React.createRef();
    this.catigesonsurecler_219090_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_328449_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_4244_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_494854_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_592482_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_944389_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_600320_value_kuikaAutoCompleteRef =
      React.createRef();
    this.catigesonsurecler_372323_value_kuikaTextInputRef = React.createRef();
    this.catigesonsurecler_775136_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_467193_value_kuikaTableRef = React.createRef();
    this.catigesonsurecler_594487_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GET_ON_SUREC_OZET_GETIR: [],
      GetUserByUsername: [],
      AktifSirketGetir: [],
      GET_SATIS_TEMSILCISI: [],
      GetProjeAsamalari: [],
      GET_PROJE_ON_SUREC: [],
      GET_NETSIS_STOK_LISTESI: [],
      CATI_GES_ON_KESIF_GETIR: [],
      PROJE_DOSYLARI_GETIR: [],
      DosyalariDBdenYukle: [],
      DosyalariGetir: [],
      ON_KESIF_KALEMLER_GETIR: [],
      KalemleriDBdenYukle: [],
      KalemleriGetir: [],
      SetValueOf: "",
      KalemSil: [],
      Notify: false,
      Multiply: 0,
      KalemEkle: [],
      UploadFile: [],
      ForEach: false,
      DownloadFile: "",
      DosyaSil: [],
      KESIF_CATI_KAYDET: [],
      IfThenElse: false,
      KaydetHazirla: "",
      ON_KESIF_KALEMLER_TOPLU_KAYDET: [],
      DosyalariKaydetHazirla: "",
      TopluDosyaKaydet: [],
      OnayDurumuKontrol: [],
      PROFORMA_GENEL_BILGILERI_GETIR: [],
      PROFORMA_KALEMLERI_GETIR: [],
      ON_KESIF_PROFORMA_KAYDET: [],
      KESIF_ONAY: [],
      NET_KESIF_CATI_GETIR: [],
      GET_PROJEYONETICI_USERS: [],
      ON_SUREC_PM_GERI_AL: [],
      ON_SUREC_PM_ONAYLA: [],
      ON_SUREC_UY_ONAY_GERIAL: [],
      ON_SUREC_UY_ONAYLA: [],
      dataSource_707377: [
        { key: "Sanayi", text: "Sanayi" },
        { key: "Ticari", text: "Ticari" },
        { key: "Mesken", text: "Mesken" },
      ],
      dataSource_166467: [
        { key: "Sandviç Panel ", text: "Sandviç Panel " },
        { key: "Kenet Çatı", text: "Kenet Çatı" },
        { key: "Betonarme", text: "Betonarme" },
        { key: "Trapez Sac", text: "Trapez Sac" },
        { key: "Kiremit", text: "Kiremit" },
      ],
      dataSource_380385: [
        { key: "Güney", text: "Güney" },
        { key: "Doğu-Batı", text: "Doğu-Batı" },
        { key: "Kuzey", text: "Kuzey" },
      ],
      dataSource_681014: [
        { key: "Çelik Konstrüksiyon", text: "Çelik Konstrüksiyon" },
        { key: "Prefabrik Beton", text: "Prefabrik Beton" },
        { key: "Ahşap", text: "Ahşap" },
      ],
      dataSource_569086: [
        { key: "Sanayi", text: "Sanayi" },
        { key: "Ticari", text: "Ticari" },
        { key: "Mesken", text: "Mesken" },
      ],
      dataSource_940300: [
        { key: "Sandviç Panel ", text: "Sandviç Panel " },
        { key: "Kenet Çatı", text: "Kenet Çatı" },
        { key: "Betonarme", text: "Betonarme" },
        { key: "Trapez Sac", text: "Trapez Sac" },
        { key: "Kiremit", text: "Kiremit" },
      ],
      dataSource_775375: [
        { key: "Güney", text: "Güney" },
        { key: "Doğu-Batı", text: "Doğu-Batı" },
        { key: "Kuzey", text: "Kuzey" },
      ],
      dataSource_868333: [
        { key: "Çelik Konstrüksiyon", text: "Çelik Konstrüksiyon" },
        { key: "Prefabrik Beton", text: "Prefabrik Beton" },
        { key: "Ahşap", text: "Ahşap" },
      ],
      isComp930685Visible: "hidden",
      isComp200548Visible: "hidden",
      isComp38139Visible: "hidden",
      isComp230193Visible: "hidden",
      isComp108416Visible: "hidden",
      isComp167824Visible: "hidden",
      isComp995070Visible: "hidden",
      isComp606562Visible: "hidden",
      isComp777039Visible: "hidden",
      isComp682157Visible: "hidden",
      isComp457735Visible: "hidden",
      isComp615511Visible: "hidden",
      isComp340168Visible: "hidden",
      isComp843199Visible: "hidden",
      isComp825089Visible: "hidden",
      isComp340333Visible: "hidden",
      isComp589579Visible: "hidden",
      isComp278838Visible: "hidden",
      isComp788639Visible: "hidden",
      isComp557821Visible: "hidden",
      isComp171830Visible: "hidden",
      isComp485928Visible: "hidden",
      isComp429832Visible: "hidden",
      isComp384588Visible: "hidden",
      isComp814465Visible: "hidden",
      isComp831693Visible: "hidden",
      isComp551404Visible: "hidden",
      isComp687126Visible: "hidden",
      isComp52540Visible: "hidden",
      isComp647527Visible: "hidden",
      isComp371141Visible: "hidden",
      isComp583734Visible: "hidden",
      isComp3461Visible: "hidden",
      isComp848368Visible: "hidden",
      isComp135945Visible: "hidden",
      isComp289590Visible: "hidden",
      isComp432583Visible: "hidden",
      isComp781192Visible: "hidden",
      isComp465589Visible: "hidden",
      isComp848477Visible: "hidden",
      isComp500544Visible: "hidden",
      isComp233488Visible: "hidden",
      isComp320489Visible: "hidden",
      isComp480487Enabled: "disabled",
      isComp353063Enabled: "disabled",
      isComp570640Enabled: "disabled",
      isComp658487Enabled: "disabled",
      isComp641491Enabled: "disabled",
      isComp864664Enabled: "disabled",
      isComp180639Enabled: "disabled",
      isComp153946Enabled: "disabled",
      isComp596085Enabled: "disabled",
      isComp123507Enabled: "disabled",
      isCompcatigesonsurecler_261399AuthorizationVisible: "visible",
      isCompcatigesonsurecler_367991AuthorizationVisible: "visible",
      isCompcatigesonsurecler_832682AuthorizationVisible: "visible",
      isCompcatigesonsurecler_648652AuthorizationVisible: "visible",
      isCompcatigesonsurecler_899938AuthorizationVisible: "visible",
      isCompcatigesonsurecler_442005AuthorizationVisible: "visible",
      isCompcatigesonsurecler_494735AuthorizationVisible: "visible",
      isCompcatigesonsurecler_135945AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("catigesonsurecler", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.CatiGesOnSureclerPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_261399AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "SatisTemsilcisi",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_367991AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "SatisTemsilcisi",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_832682AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "SatisTemsilcisi",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_648652AuthorizationVisible",
      ["06be6eb0-5136-2612-4c7e-0eb322469265", "AdminYonetici"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_899938AuthorizationVisible",
      [
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_442005AuthorizationVisible",
      [
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_494735AuthorizationVisible",
      ["06be6eb0-5136-2612-4c7e-0eb322469265", "AdminYonetici"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompcatigesonsurecler_135945AuthorizationVisible",
      [
        "c6f29069-ffbd-951c-18cd-094e80904f66",
        "f78ce546-5305-afb9-7ce9-25deaa006292",
        "06be6eb0-5136-2612-4c7e-0eb322469265",
        "SatisTemsilcisi",
        "ProjeYonetici",
        "AdminYonetici",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("catigesonsurecler", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = [
      "SatisTemsilcisi",
      "ProjeYonetici",
      "AdminYonetici",
    ];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("catigesonsurecler", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.CatiGesOnSureclerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      catigesonsurecler_913183_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kesifTarihi ?? undefined,
      catigesonsurecler_662082_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kUserID ?? undefined,
      catigesonsurecler_203346_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.adaParselBilgisi ??
        undefined,
      catigesonsurecler_14467_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.sozlesmeGucu_kW ??
        undefined,
      catigesonsurecler_707377_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.aboneTipi ?? undefined,
      catigesonsurecler_766200_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.trafoGucu_kVA ?? undefined,
      catigesonsurecler_145387_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.anaŞalterAkim_A ??
        undefined,
      catigesonsurecler_743336_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.panoMesafesi_m ??
        undefined,
      catigesonsurecler_166467_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTipi ?? undefined,
      catigesonsurecler_724523_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiEgimi_Derece ??
        undefined,
      catigesonsurecler_380385_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiYonu ?? undefined,
      catigesonsurecler_886075_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kullanilabilirAlan_m2 ??
        undefined,
      catigesonsurecler_950845_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.tahminiGuc_kWp ??
        undefined,
      catigesonsurecler_323299_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kullanilabilirAlan_m2 ??
        undefined,
      catigesonsurecler_246942_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.golgelenmeDurumu ??
        undefined,
      catigesonsurecler_681014_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      catigesonsurecler_585296_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.hadveAraligi_m ??
        undefined,
      catigesonsurecler_629508_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kaplamaDurumu ?? undefined,
      catigesonsurecler_946973_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.vincKurulumAlani ??
        undefined,
      catigesonsurecler_394531_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.inverterMontajYeri ??
        undefined,
      catigesonsurecler_397937_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kabloYoluGuzergahi ??
        undefined,
      catigesonsurecler_207266_value: undefined,
      catigesonsurecler_353063_value: 0,
      catigesonsurecler_570640_value: 0,
      catigesonsurecler_225026_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(-1)?.kesif_Aciklama1 ??
        undefined,
      catigesonsurecler_26200_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(-1)?.kesif_Aciklama2 ??
        undefined,
      catigesonsurecler_122352_value:
        this.state.CATI_GES_ON_KESIF_GETIR?.at?.(0)?.kesif_Aciklama3 ??
        undefined,
      catigesonsurecler_505390_value:
        this.state.PROFORMA_GENEL_BILGILERI_GETIR?.at?.(0)?.proforma_Tutar ??
        undefined,
      catigesonsurecler_169821_value:
        this.state.PROFORMA_GENEL_BILGILERI_GETIR?.at?.(0)?.proforma_Notu ??
        undefined,
      catigesonsurecler_990822_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kesifTarihi ?? undefined,
      catigesonsurecler_864033_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kullaniciId ?? undefined,
      catigesonsurecler_784281_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.adaParselBilgisi ?? undefined,
      catigesonsurecler_798603_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.sozlesmeGucu_kW ?? undefined,
      catigesonsurecler_569086_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.aboneTipi ?? undefined,
      catigesonsurecler_865048_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.trafoGucu_kVA ?? undefined,
      catigesonsurecler_907314_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.anaŞalterAkim_A ?? undefined,
      catigesonsurecler_320637_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.panoMesafesi_m ?? undefined,
      catigesonsurecler_940300_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiTipi ?? undefined,
      catigesonsurecler_967785_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiEgimi_Derece ?? undefined,
      catigesonsurecler_775375_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiYonu ?? undefined,
      catigesonsurecler_257886_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kullanilabilirAlan_m2 ??
        undefined,
      catigesonsurecler_672009_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.tahminiGuc_kWp ?? undefined,
      catigesonsurecler_235750_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kullanilabilirAlan_m2 ??
        undefined,
      catigesonsurecler_568262_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.golgelenmeDurumu ?? undefined,
      catigesonsurecler_868333_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.catiTasiyiciSistem ??
        undefined,
      catigesonsurecler_219090_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.hadveAraligi_m ?? undefined,
      catigesonsurecler_328449_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kaplamaDurumu ?? undefined,
      catigesonsurecler_4244_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.vincKurulumAlani ?? undefined,
      catigesonsurecler_494854_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.inverterMontajYeri ??
        undefined,
      catigesonsurecler_592482_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.kabloYoluGuzergahi ??
        undefined,
      catigesonsurecler_102756_value: undefined,
      catigesonsurecler_180639_value: 0,
      catigesonsurecler_153946_value: 0,
      catigesonsurecler_490847_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.netKesif_Aciklama1 ??
        undefined,
      catigesonsurecler_668639_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.netKesif_Aciklama2 ??
        undefined,
      catigesonsurecler_91916_value:
        this.state.NET_KESIF_CATI_GETIR?.at?.(0)?.netKesif_Aciklama3 ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  CatiGesOnSureclerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      UserName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_ON_SUREC_OZET_GETIR = result?.data.geT_ON_SUREC_OZET_GETIR;
    formVars.catigesonsurecler_271446_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_585180_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_491925_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
        : null
    );
    formVars.catigesonsurecler_135540_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_554247_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );
    formVars.catigesonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );
    formVars.catigesonsurecler_286346_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_725534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_82922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_21963_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );
    formVars.catigesonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.catigesonsurecler_726292_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.catigesonsurecler_726526_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.catigesonsurecler_735264_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.catigesonsurecler_365802_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.catigesonsurecler_511988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_979930_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );
    formVars.catigesonsurecler_120818_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );
    formVars.catigesonsurecler_300623_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );
    formVars.catigesonsurecler_379284_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );
    formVars.catigesonsurecler_357016_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_455222_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_402895_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_625966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_514278_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );
    formVars.catigesonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.catigesonsurecler_936865_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.catigesonsurecler_199667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.catigesonsurecler_330741_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.catigesonsurecler_76435_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.catigesonsurecler_678296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_197581_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );
    formVars.catigesonsurecler_4809_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );
    formVars.catigesonsurecler_969958_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );
    formVars.catigesonsurecler_905887_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );
    formVars.catigesonsurecler_958888_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_156155_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_987296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_179447_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_451953_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );
    formVars.catigesonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.catigesonsurecler_117221_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.catigesonsurecler_621424_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.catigesonsurecler_615433_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.catigesonsurecler_64459_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.catigesonsurecler_619277_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_676113_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );
    formVars.catigesonsurecler_395234_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );
    formVars.catigesonsurecler_554511_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );
    formVars.catigesonsurecler_688343_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );
    stateVars.isComp930685Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp200548Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp38139Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp230193Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp108416Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp167824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp995070Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp606562Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp777039Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp682157Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp457735Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825089Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp340333Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589579Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp278838Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788639Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp557821Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp171830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp485928Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp429832Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp384588Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814465Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp831693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp551404Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687126Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp52540Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp647527Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp371141Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp583734Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp3461Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848368Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp135945Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp289590Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432583Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp781192Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465589Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848477Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500544Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp233488Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp320489Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp641491Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp596085Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.GET_SATIS_TEMSILCISI = result?.data.geT_SATIS_TEMSILCISI;

    formVars.catigesonsurecler_662082_options = stateVars.GET_SATIS_TEMSILCISI;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.CatiGesOnSureclerPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.catigesonsurecler_271446_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_585180_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_491925_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
        : null
    );

    formVars.catigesonsurecler_135540_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_554247_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );

    formVars.catigesonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );

    formVars.catigesonsurecler_286346_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_725534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_82922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_21963_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );

    stateVars.isComp930685Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.catigesonsurecler_726292_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    stateVars.isComp200548Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp38139Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.catigesonsurecler_726526_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );

    stateVars.isComp230193Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp108416Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.catigesonsurecler_735264_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    stateVars.isComp167824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp995070Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.catigesonsurecler_365802_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );

    stateVars.isComp606562Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp777039Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.catigesonsurecler_511988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );

    stateVars.isComp682157Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp457735Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_979930_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );

    formVars.catigesonsurecler_120818_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );

    formVars.catigesonsurecler_300623_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );

    formVars.catigesonsurecler_379284_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );

    stateVars.dataSource_662082 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    stateVars.dataSource_662082 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    stateVars.isComp658487Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp641491Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp615511Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp864664Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp596085Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp843199Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_357016_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_455222_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_402895_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_625966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_514278_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );

    stateVars.isComp825089Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.catigesonsurecler_936865_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    stateVars.isComp340333Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589579Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.catigesonsurecler_199667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );

    stateVars.isComp278838Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788639Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.catigesonsurecler_330741_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    stateVars.isComp557821Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp171830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.catigesonsurecler_76435_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );

    stateVars.isComp485928Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp429832Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.catigesonsurecler_678296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );

    stateVars.isComp384588Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814465Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_197581_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );

    formVars.catigesonsurecler_4809_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );

    formVars.catigesonsurecler_969958_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );

    formVars.catigesonsurecler_905887_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );

    stateVars.isComp831693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp551404Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687126Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp123507Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.catigesonsurecler_958888_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_156155_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_987296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_179447_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_451953_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );

    stateVars.isComp52540Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.catigesonsurecler_117221_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    stateVars.isComp647527Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp371141Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.catigesonsurecler_621424_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );

    stateVars.isComp583734Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp3461Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.catigesonsurecler_615433_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    stateVars.isComp848368Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp135945Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.catigesonsurecler_64459_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );

    stateVars.isComp289590Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432583Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.catigesonsurecler_619277_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );

    stateVars.isComp781192Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465589Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.catigesonsurecler_676113_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );

    formVars.catigesonsurecler_395234_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );

    formVars.catigesonsurecler_554511_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );

    formVars.catigesonsurecler_688343_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );

    stateVars.isComp848477Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500544Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp233488Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp320489Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_838016_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_490554_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KategoriKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("CATI_GES", "string"),
        "string"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      ProjeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_490554_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProjeAsamalari = result?.data.getProjeAsamalari;
    stateVars.GET_ON_SUREC_OZET_GETIR = result?.data.geT_ON_SUREC_OZET_GETIR;
    formVars.catigesonsurecler_271446_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_585180_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_491925_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
        : null
    );
    formVars.catigesonsurecler_135540_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_554247_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );
    formVars.catigesonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );
    formVars.catigesonsurecler_286346_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_725534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_82922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_21963_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );
    formVars.catigesonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.catigesonsurecler_726292_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.catigesonsurecler_726526_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.catigesonsurecler_735264_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.catigesonsurecler_365802_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.catigesonsurecler_511988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_979930_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );
    formVars.catigesonsurecler_120818_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );
    formVars.catigesonsurecler_300623_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );
    formVars.catigesonsurecler_379284_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );
    formVars.catigesonsurecler_357016_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_455222_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_402895_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_625966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_514278_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );
    formVars.catigesonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.catigesonsurecler_936865_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.catigesonsurecler_199667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.catigesonsurecler_330741_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.catigesonsurecler_76435_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.catigesonsurecler_678296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_197581_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );
    formVars.catigesonsurecler_4809_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );
    formVars.catigesonsurecler_969958_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );
    formVars.catigesonsurecler_905887_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );
    formVars.catigesonsurecler_958888_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );
    formVars.catigesonsurecler_156155_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );
    formVars.catigesonsurecler_987296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );
    formVars.catigesonsurecler_179447_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );
    formVars.catigesonsurecler_451953_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );
    formVars.catigesonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );
    formVars.catigesonsurecler_117221_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );
    formVars.catigesonsurecler_621424_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );
    formVars.catigesonsurecler_615433_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );
    formVars.catigesonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );
    formVars.catigesonsurecler_64459_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );
    formVars.catigesonsurecler_619277_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );
    formVars.catigesonsurecler_676113_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );
    formVars.catigesonsurecler_395234_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );
    formVars.catigesonsurecler_554511_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );
    formVars.catigesonsurecler_688343_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );
    stateVars.isComp930685Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp200548Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp38139Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp230193Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp108416Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp167824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp995070Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp606562Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp777039Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp682157Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp457735Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp825089Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp340333Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp589579Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp278838Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp788639Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp557821Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp171830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp485928Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp429832Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp384588Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp814465Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp831693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp551404Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp687126Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp52540Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp647527Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp371141Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp583734Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp3461Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848368Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp135945Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp289590Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp432583Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp781192Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnaylayanAdi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp465589Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848477Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp500544Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp233488Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp320489Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].uY_OnayDurum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp641491Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp596085Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciId
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_490554_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_490554_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.catigesonsurecler_271446_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_585180_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_491925_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].projeAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].projeAdi
        : null
    );

    formVars.catigesonsurecler_135540_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_554247_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_470797_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].baslangicTarihi
        : null
    );

    formVars.catigesonsurecler_931176_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].tahminiBitis
        : null
    );

    formVars.catigesonsurecler_286346_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_725534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_82922_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_548_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_21963_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );

    formVars.catigesonsurecler_819965_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.catigesonsurecler_726292_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_32769_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.catigesonsurecler_726526_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_776921_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.catigesonsurecler_735264_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_916010_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.catigesonsurecler_365802_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );

    formVars.catigesonsurecler_295328_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.catigesonsurecler_511988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );

    formVars.catigesonsurecler_979930_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );

    formVars.catigesonsurecler_120818_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );

    formVars.catigesonsurecler_300623_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );

    formVars.catigesonsurecler_379284_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );

    formVars.catigesonsurecler_357016_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_455222_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_402895_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_625966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_514278_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );

    formVars.catigesonsurecler_784309_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.catigesonsurecler_936865_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_115403_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.catigesonsurecler_199667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_122248_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.catigesonsurecler_330741_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_977440_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.catigesonsurecler_76435_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );

    formVars.catigesonsurecler_585379_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.catigesonsurecler_678296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );

    formVars.catigesonsurecler_197581_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );

    formVars.catigesonsurecler_4809_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );

    formVars.catigesonsurecler_969958_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );

    formVars.catigesonsurecler_905887_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );

    formVars.catigesonsurecler_958888_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kategoriAdi
        : null
    );

    formVars.catigesonsurecler_156155_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
        : null
    );

    formVars.catigesonsurecler_987296_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].musteriAdi
        : null
    );

    formVars.catigesonsurecler_179447_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].iletisimKisi
        : null
    );

    formVars.catigesonsurecler_451953_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].telefon
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].telefon
        : null
    );

    formVars.catigesonsurecler_106507_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_Tarih
        : null
    );

    formVars.catigesonsurecler_117221_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_686232_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_Tarih
        : null
    );

    formVars.catigesonsurecler_621424_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].proforma_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_112950_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_Tarih
        : null
    );

    formVars.catigesonsurecler_615433_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].netKesif_KullaniciAdi
        : null
    );

    formVars.catigesonsurecler_140697_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnayTarih
        : null
    );

    formVars.catigesonsurecler_64459_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].pM_OnaylayanAdi
        : null
    );

    formVars.catigesonsurecler_616609_value = ReactSystemFunctions.value(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnayTarih
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnayTarih
        : null
    );

    formVars.catigesonsurecler_619277_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[
              stateVars.GET_ON_SUREC_OZET_GETIR.length - 1
            ].uY_OnaylayanAdi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[
            this.state.GET_ON_SUREC_OZET_GETIR.length - 1
          ].uY_OnaylayanAdi
        : null
    );

    formVars.catigesonsurecler_676113_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_TahminiGuc
        : null
    );

    formVars.catigesonsurecler_395234_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].kesif_AlanM2
        : null
    );

    formVars.catigesonsurecler_554511_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].teknik_CatiTipi
        : null
    );

    formVars.catigesonsurecler_688343_value = ReactSystemFunctions.toString(
      this,
      stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
        ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
          ? stateVars.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
          : null
        : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
        ? this.state.GET_ON_SUREC_OZET_GETIR[0].onKesif_ToplamMaliyet
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_367991_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      DbName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_3: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ProjeId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      ProjeId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_367991_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.GET_SATIS_TEMSILCISI = result?.data.geT_SATIS_TEMSILCISI;

    formVars.catigesonsurecler_662082_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kUserID
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kUserID
        : null;
    formVars.catigesonsurecler_662082_options = stateVars.GET_SATIS_TEMSILCISI;
    stateVars.GET_PROJE_ON_SUREC = result?.data.geT_PROJE_ON_SUREC;
    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_600320_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    stateVars.CATI_GES_ON_KESIF_GETIR = result?.data.catI_GES_ON_KESIF_GETIR;
    formVars.catigesonsurecler_913183_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kesifTarihi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kesifTarihi
        : null
    );
    formVars.catigesonsurecler_662082_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kUserID
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kUserID
        : null;
    formVars.catigesonsurecler_662082_options = stateVars.GET_SATIS_TEMSILCISI;
    formVars.catigesonsurecler_203346_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
        : null
    );
    formVars.catigesonsurecler_14467_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
        : null
    );
    formVars.catigesonsurecler_707377_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
        : null;
    formVars.catigesonsurecler_766200_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
        : null
    );
    formVars.catigesonsurecler_145387_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
        : null
    );
    formVars.catigesonsurecler_743336_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.catigesonsurecler_166467_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTipi
        : null;
    formVars.catigesonsurecler_724523_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.catigesonsurecler_380385_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null;
    formVars.catigesonsurecler_886075_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );
    formVars.catigesonsurecler_950845_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].tahminiGuc_kWp
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].tahminiGuc_kWp
        : null
    );
    formVars.catigesonsurecler_323299_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );
    formVars.catigesonsurecler_246942_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].golgelenmeDurumu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].golgelenmeDurumu
        : null
    );
    formVars.catigesonsurecler_681014_value =
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.catigesonsurecler_585296_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].hadveAraligi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].hadveAraligi_m
        : null
    );
    formVars.catigesonsurecler_629508_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kaplamaDurumu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kaplamaDurumu
        : null
    );
    formVars.catigesonsurecler_946973_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].vincKurulumAlani
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].vincKurulumAlani
        : null
    );
    formVars.catigesonsurecler_394531_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].inverterMontajYeri
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].inverterMontajYeri
        : null
    );
    formVars.catigesonsurecler_397937_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kabloYoluGuzergahi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kabloYoluGuzergahi
        : null
    );
    formVars.catigesonsurecler_225026_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[
              stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama1
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[
            this.state.CATI_GES_ON_KESIF_GETIR.length - 1
          ].kesif_Aciklama1
        : null
    );
    formVars.catigesonsurecler_26200_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[
              stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[
            this.state.CATI_GES_ON_KESIF_GETIR.length - 1
          ].kesif_Aciklama2
        : null
    );
    formVars.catigesonsurecler_122352_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
        : null
    );
    stateVars.PROJE_DOSYLARI_GETIR = result?.data.projE_DOSYLARI_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_367991_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_367991_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariDBdenYukle = CWTypeScript.DosyalariDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.PROJE_DOSYLARI_GETIR)
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_367991_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_367991_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_367991_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_367991_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_367991_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_913183_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kesifTarihi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kesifTarihi
        : null
    );

    formVars.catigesonsurecler_662082_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kUserID
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kUserID
        : null
    );

    stateVars.dataSource_662082 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    stateVars.dataSource_662082 =
      stateVars.GET_SATIS_TEMSILCISI ?? this.state.GET_SATIS_TEMSILCISI;
    formVars.catigesonsurecler_203346_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].adaParselBilgisi
        : null
    );

    formVars.catigesonsurecler_14467_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].sozlesmeGucu_kW
        : null
    );

    formVars.catigesonsurecler_707377_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].aboneTipi
        : null
    );

    formVars.catigesonsurecler_766200_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].trafoGucu_kVA
        : null
    );

    formVars.catigesonsurecler_145387_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].anaŞalterAkim_A
        : null
    );

    formVars.catigesonsurecler_743336_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.catigesonsurecler_166467_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTipi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTipi
        : null
    );

    formVars.catigesonsurecler_724523_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.catigesonsurecler_380385_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiYonu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiYonu
        : null
    );

    formVars.catigesonsurecler_886075_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );

    formVars.catigesonsurecler_950845_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].tahminiGuc_kWp
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].tahminiGuc_kWp
        : null
    );

    formVars.catigesonsurecler_323299_value = ReactSystemFunctions.value(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kullanilabilirAlan_m2
        : null
    );

    formVars.catigesonsurecler_246942_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].golgelenmeDurumu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].golgelenmeDurumu
        : null
    );

    formVars.catigesonsurecler_681014_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].catiTasiyiciSistem
        : null
    );

    formVars.catigesonsurecler_585296_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].hadveAraligi_m
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].hadveAraligi_m
        : null
    );

    formVars.catigesonsurecler_629508_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kaplamaDurumu
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kaplamaDurumu
        : null
    );

    formVars.catigesonsurecler_946973_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].vincKurulumAlani
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].vincKurulumAlani
        : null
    );

    formVars.catigesonsurecler_394531_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].inverterMontajYeri
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].inverterMontajYeri
        : null
    );

    formVars.catigesonsurecler_397937_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kabloYoluGuzergahi
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kabloYoluGuzergahi
        : null
    );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    formVars.catigesonsurecler_225026_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[
              stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama1
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[
            this.state.CATI_GES_ON_KESIF_GETIR.length - 1
          ].kesif_Aciklama1
        : null
    );

    formVars.catigesonsurecler_26200_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[
              stateVars.CATI_GES_ON_KESIF_GETIR.length - 1
            ].kesif_Aciklama2
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[
            this.state.CATI_GES_ON_KESIF_GETIR.length - 1
          ].kesif_Aciklama2
        : null
    );

    formVars.catigesonsurecler_122352_value = ReactSystemFunctions.toString(
      this,
      stateVars.CATI_GES_ON_KESIF_GETIR !== undefined
        ? stateVars.CATI_GES_ON_KESIF_GETIR?.length > 0
          ? stateVars.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
          : null
        : this.state.CATI_GES_ON_KESIF_GETIR?.length > 0
        ? this.state.CATI_GES_ON_KESIF_GETIR[0].kesif_Aciklama3
        : null
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_78287_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_393036_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_478263_value",
        "stokKodu"
      ),
      null,
      "STOK_KODU"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_207266_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_478263_value",
        "miktar"
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_285034_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KalemSil = CWTypeScript.KalemSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_478263_value",
        "stokKodu"
      )
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "4b1e2c66_37b7_c891_1819_cb2547759127_notify",
        this.defaultML,
        "Kalem Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_393036_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_393036_value",
            "",
            "GET_NETSIS_STOK_LISTESI",
            "stoK_KODU",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_393036_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_600320_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_393036_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_393036_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_393036_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_353063_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "satiS_FIAT1"
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_207266_value",
        "string"
      ),
      1,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_480487_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "olcU_BR1"
        )
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_207266_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Multiply = await ReactSystemFunctions.multiply(
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_353063_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_207266_value",
          "value",
          "",
          "",
          ""
        )
      )
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_570640_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.Multiply),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_740127_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          ""
        ),
        null
      ),
      message: "Bu alanın doldurulması zorunludur.",
      formName: "catigesonsurecler_393036_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_207266_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Bu alanın doldurulması zorunludur.",
      formName: "catigesonsurecler_207266_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KalemEkle = CWTypeScript.KalemEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "stoK_KODU"
        )
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_393036_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "stoK_ADI"
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_480487_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_353063_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_207266_value",
          "value",
          "",
          "",
          ""
        )
      )
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_393036_value",
        "string"
      ),
      null,
      null,
      "STOK_KODU"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_353063_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_570640_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_207266_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_480487_value",
        "string"
      ),
      null,
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_740127_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_740127_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.KalemleriGetir !== undefined
            ? stateVars.KalemleriGetir?.length > 0
              ? stateVars.KalemleriGetir[0].sonuc
              : null
            : this.state.KalemleriGetir?.length > 0
            ? this.state.KalemleriGetir[0].sonuc
            : null
        ),
        "KALEM MEVCUT"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "28390ac9_7ba2_881f_ca06_d404be3e56e4_notify",
          this.defaultML,
          "Seçtiğiniz ürün listede zaten mevcuttur."
        ),
        ReactSystemFunctions.convertToTypeByName("info", "string"),
        ReactSystemFunctions.convertToTypeByName("center", "string"),
        4,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.CatiGesOnSureclerComponent_740127_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.CatiGesOnSureclerComponent_740127_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_740127_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_261776_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_261776_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_261776_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaEkle = CWTypeScript.DosyaEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.ForEach4?.name),
      ReactSystemFunctions.value(this, this.ForEach4?.data),
      ReactSystemFunctions.value(this, this.ForEach4?.type),
      ReactSystemFunctions.value(this, this.ForEach4?.size)
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_261776_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.UploadFile)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.UploadFile
      )) {
        this.ForEach4 = item;
        await this.CatiGesOnSureclerComponent_261776_onClick_foreach1();
      }
    }

    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_218119_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_801362_value",
        "base64Icerik"
      ),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_801362_value",
        "dosyaAdi"
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_885016_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaSil = CWTypeScript.DosyaSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_801362_value",
        "dosyaAdi"
      )
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "6e1d75f9_0024_60ed_5f1f_5011eeeae21a_notify",
        this.defaultML,
        "Dosya Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_970414_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_662082_value",
            "value",
            "GET_SATIS_TEMSILCISI",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      KesifTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_913183_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      AdaParselBilgisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_203346_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SozlesmeGucu_kW_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_14467_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      AboneTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_707377_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TrafoGucu_kVA_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_766200_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      AnaSalterAkim_A_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_145387_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PanoMesafesi_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_743336_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CatiTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_166467_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CatiEgimi_Derece_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_724523_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CatiYonu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_380385_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      KullanilabilirAlan_m2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_886075_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TahminiGuc_kWp_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_950845_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GolgelenmeDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_246942_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CatiTasiyiciSistem_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_681014_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      HadveAraligi_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toDecimal(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_585296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KaplamaDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_246942_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      VincKurulumAlani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_946973_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      InverterMontajYeri_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_585296_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KabloYoluGuzergahi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_629508_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_225026_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_26200_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_122352_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_970414_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KESIF_CATI_KAYDET = result?.data.kesiF_CATI_KAYDET;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_970414_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_970414_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "b500d4fa_6a3b_f214_cfa4_b11169bfab49_notify",
        this.defaultML,
        "Kar oranı %20 den düşük olduğu için Proje Yönetici onayına gönderildi"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_970414_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.KESIF_CATI_KAYDET !== undefined
          ? stateVars.KESIF_CATI_KAYDET?.length > 0
            ? stateVars.KESIF_CATI_KAYDET[0].sonuc
            : null
          : this.state.KESIF_CATI_KAYDET?.length > 0
          ? this.state.KESIF_CATI_KAYDET[0].sonuc
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_970414_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.KESIF_CATI_KAYDET !== undefined
            ? stateVars.KESIF_CATI_KAYDET?.length > 0
              ? stateVars.KESIF_CATI_KAYDET[0].onayGerekli
              : null
            : this.state.KESIF_CATI_KAYDET?.length > 0
            ? this.state.KESIF_CATI_KAYDET[0].onayGerekli
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_970414_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_970414_onClick_else1();
      if (isErrorOccurred) return true;
    }

    stateVars.KaydetHazirla = CWTypeScript.KaydetHazirla(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_970414_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_970414_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
      KalemlerJson_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.KaydetHazirla),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_970414_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_TOPLU_KAYDET =
      result?.data.oN_KESIF_KALEMLER_TOPLU_KAYDET;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_970414_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_970414_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariKaydetHazirla = CWTypeScript.DosyalariKaydetHazirla(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_970414_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_970414_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
      DosyalarJson_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.DosyalariKaydetHazirla),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_970414_onClick4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TopluDosyaKaydet = result?.data.topluDosyaKaydet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_970414_onClick5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_970414_onClick_if5 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "1c254ec9_3cb5_bf05_2a3b_5c1ff8e581dd_notify",
        this.defaultML,
        "Kar oranı %20 den düşük olduğu için Proje Yönetici onayına gönderildi"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_970414_onClick_else5 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.KESIF_CATI_KAYDET !== undefined
          ? stateVars.KESIF_CATI_KAYDET?.length > 0
            ? stateVars.KESIF_CATI_KAYDET[0].sonuc
            : null
          : this.state.KESIF_CATI_KAYDET?.length > 0
          ? this.state.KESIF_CATI_KAYDET[0].sonuc
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_970414_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.KESIF_CATI_KAYDET !== undefined
            ? stateVars.KESIF_CATI_KAYDET?.length > 0
              ? stateVars.KESIF_CATI_KAYDET[0].onayGerekli
              : null
            : this.state.KESIF_CATI_KAYDET?.length > 0
            ? this.state.KESIF_CATI_KAYDET[0].onayGerekli
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_970414_onClick_if5();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_970414_onClick_else5();
      if (isErrorOccurred) return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_832682_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_832682_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OnayDurumuKontrol = result?.data.onayDurumuKontrol;
    stateVars.isComp615511Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp843199Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp658487Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp864664Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp123507Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "90b046a0_c1aa_ae68_476a_c4d40304ee35_notify",
        this.defaultML,
        "Bu adım bilgilerini girmeniz için ilgili proje için yönetici onayı gerekmektedir."
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_832682_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        "SERBEST"
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_832682_onActive_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_832682_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_832682_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROJE_DOSYLARI_GETIR = result?.data.projE_DOSYLARI_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariDBdenYukle = CWTypeScript.DosyalariDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
      ReactSystemFunctions.value(this, this.state.PROJE_DOSYLARI_GETIR)
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive6_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      DbName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      ProjeKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_832682_onActive6_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROFORMA_GENEL_BILGILERI_GETIR =
      result?.data.proformA_GENEL_BILGILERI_GETIR;
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_169821_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
        : null
    );
    stateVars.PROFORMA_KALEMLERI_GETIR = result?.data.proformA_KALEMLERI_GETIR;

    formVars.catigesonsurecler_751518_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    formVars.catigesonsurecler_968343_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    formVars.catigesonsurecler_575347_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_832682_onActive7_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_832682_onActive7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_899735 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_751518_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    formVars.catigesonsurecler_169821_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Notu
        : null
    );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_467193 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_968343_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    stateVars.dataSource_594487 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_575347_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_410008_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_410008_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_410008_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaEkle = CWTypeScript.DosyaEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
      ReactSystemFunctions.value(this, this.ForEach5?.name),
      ReactSystemFunctions.value(this, this.ForEach5?.data),
      ReactSystemFunctions.value(this, this.ForEach5?.type),
      ReactSystemFunctions.value(this, this.ForEach5?.size)
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_410008_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.UploadFile)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.UploadFile
      )) {
        this.ForEach5 = item;
        await this.CatiGesOnSureclerComponent_410008_onClick_foreach1();
      }
    }

    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_931911_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_266261_value",
        "base64Icerik"
      ),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_266261_value",
        "dosyaAdi"
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_117547_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaSil = CWTypeScript.DosyaSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_266261_value",
        "dosyaAdi"
      )
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "da838d57_3134_477a_e13c_d692eaef2802_notify",
        this.defaultML,
        "Dosya Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_641491_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyalariKaydetHazirla = CWTypeScript.DosyalariKaydetHazirla(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("PROFORMA", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_641491_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_641491_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("PROFORMA", "string"),
        "string"
      ),
      DosyalarJson_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.DosyalariKaydetHazirla),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].userName
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].userName
            : null
        ),
        "string"
      ),
      ProjeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      Proforma_Tutar_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_505390_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Proforma_DovizTipi_1: ReactSystemFunctions.convertToTypeByName(
        0,
        "number"
      ),
      Proforma_Notu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_169821_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_641491_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TopluDosyaKaydet = result?.data.topluDosyaKaydet;
    stateVars.ON_KESIF_PROFORMA_KAYDET = result?.data.oN_KESIF_PROFORMA_KAYDET;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_641491_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_641491_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d4793bb6_6eee_f607_5902_cb6d895ffb3f_notify",
        this.defaultML,
        "Proforma bilgileri başarıyla kaydedildi !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_237140_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      OnayId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      OnaylayanId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      Karar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ONAYLANDI", "string"),
        "string"
      ),
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Uygun görüldü", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_237140_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KESIF_ONAY = result?.data.kesiF_ONAY;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_237140_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_237140_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "66aa97dd_3711_5741_1689_9e09cbe04fa1_notify",
        this.defaultML,
        "Proje onaylandı !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_417687_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      OnayId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      OnaylayanId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      Karar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("REDDEDILDI", "string"),
        "string"
      ),
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Maliyet revize edilmeli",
          "string"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_417687_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KESIF_ONAY = result?.data.kesiF_ONAY;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_417687_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_417687_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "a38b1fe1_3956_44d6_d174_04528322abe2_notify",
        this.defaultML,
        "Proje reddedildi !"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_899938_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("ON_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_899938_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OnayDurumuKontrol = result?.data.onayDurumuKontrol;
    stateVars.isComp615511Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp843199Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp658487Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp864664Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp123507Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "2a8dc5c4_1f58_db4c_3496_a4d12a1ad224_notify",
        this.defaultML,
        "Bu adım bilgilerini girmeniz için ilgili proje için yönetici onayı gerekmektedir."
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_899938_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        "SERBEST"
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_899938_onActive_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DbName_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_2: ReactSystemFunctions.convertToTypeByName(null, "string"),
      ProjeID_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      ProjeId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      IslemTipi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_899938_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AktifSirketGetir = result?.data.aktifSirketGetir;
    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_600320_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    stateVars.NET_KESIF_CATI_GETIR = result?.data.neT_KESIF_CATI_GETIR;
    formVars.catigesonsurecler_990822_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kesifTarihi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kesifTarihi
        : null
    );
    formVars.catigesonsurecler_864033_value =
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kullaniciId
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kullaniciId
        : null;
    formVars.catigesonsurecler_784281_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].adaParselBilgisi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].adaParselBilgisi
        : null
    );
    formVars.catigesonsurecler_798603_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].sozlesmeGucu_kW
        : null
    );
    formVars.catigesonsurecler_569086_value =
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].aboneTipi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].aboneTipi
        : null;
    formVars.catigesonsurecler_865048_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].trafoGucu_kVA
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].trafoGucu_kVA
        : null
    );
    formVars.catigesonsurecler_907314_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].anaŞalterAkim_A
        : null
    );
    formVars.catigesonsurecler_320637_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].panoMesafesi_m
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].panoMesafesi_m
        : null
    );
    formVars.catigesonsurecler_940300_value =
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiTipi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiTipi
        : null;
    formVars.catigesonsurecler_967785_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiEgimi_Derece
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiEgimi_Derece
        : null
    );
    formVars.catigesonsurecler_775375_value =
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiYonu
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiYonu
        : null;
    formVars.catigesonsurecler_257886_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
        : null
    );
    formVars.catigesonsurecler_672009_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].tahminiGuc_kWp
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].tahminiGuc_kWp
        : null
    );
    formVars.catigesonsurecler_235750_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
        : null
    );
    formVars.catigesonsurecler_568262_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].golgelenmeDurumu
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].golgelenmeDurumu
        : null
    );
    formVars.catigesonsurecler_868333_value =
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiTasiyiciSistem
        : null;
    formVars.catigesonsurecler_219090_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].hadveAraligi_m
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].hadveAraligi_m
        : null
    );
    formVars.catigesonsurecler_328449_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kaplamaDurumu
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kaplamaDurumu
        : null
    );
    formVars.catigesonsurecler_4244_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].vincKurulumAlani
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].vincKurulumAlani
        : null
    );
    formVars.catigesonsurecler_494854_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].inverterMontajYeri
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].inverterMontajYeri
        : null
    );
    formVars.catigesonsurecler_592482_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kabloYoluGuzergahi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kabloYoluGuzergahi
        : null
    );
    formVars.catigesonsurecler_490847_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama1
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama1
        : null
    );
    formVars.catigesonsurecler_668639_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama2
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama2
        : null
    );
    formVars.catigesonsurecler_91916_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama3
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama3
        : null
    );
    stateVars.PROJE_DOSYLARI_GETIR = result?.data.projE_DOSYLARI_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DosyalariDBdenYukle = CWTypeScript.DosyalariDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.PROJE_DOSYLARI_GETIR)
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_899938_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive6_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_899938_onActive6_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_PROJEYONETICI_USERS = result?.data.geT_PROJEYONETICI_USERS;

    formVars.catigesonsurecler_864033_options =
      stateVars.GET_PROJEYONETICI_USERS;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_899938_onActive7_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_899938_onActive7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    formVars.catigesonsurecler_990822_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kesifTarihi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kesifTarihi
        : null
    );

    formVars.catigesonsurecler_864033_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kullaniciId
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kullaniciId
        : null
    );

    stateVars.dataSource_864033 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    stateVars.dataSource_864033 =
      stateVars.GET_PROJEYONETICI_USERS ?? this.state.GET_PROJEYONETICI_USERS;
    formVars.catigesonsurecler_784281_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].adaParselBilgisi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].adaParselBilgisi
        : null
    );

    formVars.catigesonsurecler_798603_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].sozlesmeGucu_kW
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].sozlesmeGucu_kW
        : null
    );

    formVars.catigesonsurecler_569086_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].aboneTipi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].aboneTipi
        : null
    );

    formVars.catigesonsurecler_865048_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].trafoGucu_kVA
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].trafoGucu_kVA
        : null
    );

    formVars.catigesonsurecler_907314_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].anaŞalterAkim_A
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].anaŞalterAkim_A
        : null
    );

    formVars.catigesonsurecler_320637_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].panoMesafesi_m
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].panoMesafesi_m
        : null
    );

    formVars.catigesonsurecler_940300_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiTipi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiTipi
        : null
    );

    formVars.catigesonsurecler_967785_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiEgimi_Derece
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiEgimi_Derece
        : null
    );

    formVars.catigesonsurecler_775375_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiYonu
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiYonu
        : null
    );

    formVars.catigesonsurecler_257886_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
        : null
    );

    formVars.catigesonsurecler_672009_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].tahminiGuc_kWp
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].tahminiGuc_kWp
        : null
    );

    formVars.catigesonsurecler_235750_value = ReactSystemFunctions.value(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kullanilabilirAlan_m2
        : null
    );

    formVars.catigesonsurecler_568262_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].golgelenmeDurumu
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].golgelenmeDurumu
        : null
    );

    formVars.catigesonsurecler_868333_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].catiTasiyiciSistem
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].catiTasiyiciSistem
        : null
    );

    formVars.catigesonsurecler_219090_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].hadveAraligi_m
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].hadveAraligi_m
        : null
    );

    formVars.catigesonsurecler_328449_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kaplamaDurumu
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kaplamaDurumu
        : null
    );

    formVars.catigesonsurecler_4244_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].vincKurulumAlani
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].vincKurulumAlani
        : null
    );

    formVars.catigesonsurecler_494854_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].inverterMontajYeri
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].inverterMontajYeri
        : null
    );

    formVars.catigesonsurecler_592482_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].kabloYoluGuzergahi
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].kabloYoluGuzergahi
        : null
    );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;

    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    formVars.catigesonsurecler_490847_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama1
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama1
        : null
    );

    formVars.catigesonsurecler_668639_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama2
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama2
        : null
    );

    formVars.catigesonsurecler_91916_value = ReactSystemFunctions.toString(
      this,
      stateVars.NET_KESIF_CATI_GETIR !== undefined
        ? stateVars.NET_KESIF_CATI_GETIR?.length > 0
          ? stateVars.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama3
          : null
        : this.state.NET_KESIF_CATI_GETIR?.length > 0
        ? this.state.NET_KESIF_CATI_GETIR[0].netKesif_Aciklama3
        : null
    );

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_600161_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KalemSil = CWTypeScript.KalemSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_944389_value",
        "stokKodu"
      )
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "98f4315f_8dd6_839c_b925_580f182b9354_notify",
        this.defaultML,
        "Kalem Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_600320_onSearch = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_600320_value",
            "",
            "GET_NETSIS_STOK_LISTESI",
            "stoK_KODU",
            "k_searchValue"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_600320_onSearch",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GET_NETSIS_STOK_LISTESI = result?.data.geT_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_393036_options =
      stateVars.GET_NETSIS_STOK_LISTESI;

    formVars.catigesonsurecler_600320_options =
      stateVars.GET_NETSIS_STOK_LISTESI;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_600320_onSearch1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_600320_onSearch1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_393036 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;
    stateVars.dataSource_600320 =
      stateVars.GET_NETSIS_STOK_LISTESI ?? this.state.GET_NETSIS_STOK_LISTESI;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_600320_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_180639_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_600320_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "satiS_FIAT1"
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_102756_value",
        "string"
      ),
      1,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_372323_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_600320_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "olcU_BR1"
        )
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_102756_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Multiply = await ReactSystemFunctions.multiply(
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_102756_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_180639_value",
          "value",
          "",
          "",
          ""
        )
      )
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_153946_value",
        "string"
      ),
      ReactSystemFunctions.value(this, stateVars.Multiply),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_978224_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_600320_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "catigesonsurecler_600320_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.KalemEkle = CWTypeScript.KalemEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_600320_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "stoK_KODU"
        )
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_600320_value",
          "value",
          "GET_NETSIS_STOK_LISTESI",
          "stoK_KODU",
          "stoK_ADI"
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_372323_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_180639_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "catigesonsurecler_153946_value",
          "value",
          "",
          "",
          ""
        )
      )
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_978224_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_978224_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_600320_value",
        "string"
      ),
      null,
      null,
      "STOK_KODU"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_102756_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_372323_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_180639_value",
        "string"
      ),
      null,
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "catigesonsurecler_153946_value",
        "string"
      ),
      null,
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_978224_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_978224_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_414931_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_414931_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_414931_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaEkle = CWTypeScript.DosyaEkle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.ForEach6?.name),
      ReactSystemFunctions.value(this, this.ForEach6?.data),
      ReactSystemFunctions.value(this, this.ForEach6?.type),
      ReactSystemFunctions.value(this, this.ForEach6?.size)
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_414931_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.UploadFile)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.UploadFile
      )) {
        this.ForEach6 = item;
        await this.CatiGesOnSureclerComponent_414931_onClick_foreach1();
      }
    }

    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_684853_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_775136_value",
        "base64Icerik"
      ),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_775136_value",
        "dosyaAdi"
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_67793_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DosyaSil = CWTypeScript.DosyaSil(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(
        this,
        "catigesonsurecler_775136_value",
        "dosyaAdi"
      )
    );
    stateVars.DosyalariGetir = CWTypeScript.DosyalariGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "20047620_8f61_e3c6_c6f4_056407de5f9f_notify",
        this.defaultML,
        "Dosya Başarıyla Silindi !"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    stateVars.dataSource_801362 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_266261 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    stateVars.dataSource_775136 =
      stateVars.DosyalariGetir ?? this.state.DosyalariGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_596085_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_864033_value",
            "value",
            "GET_PROJEYONETICI_USERS",
            "kuserid",
            "kuserid"
          )
        ),
        "string"
      ),
      KesifTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_990822_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      AdaParselBilgisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_784281_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SozlesmeGucu_kW_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_798603_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      AboneTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_569086_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TrafoGucu_kVA_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_865048_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      AnaSalterAkim_A_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_907314_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PanoMesafesi_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_320637_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CatiTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_940300_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CatiEgimi_Derece_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_967785_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CatiYonu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_775375_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      KullanilabilirAlan_m2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_257886_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      TahminiGuc_kWp_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_672009_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      GolgelenmeDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_568262_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CatiTasiyiciSistem_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_868333_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      HadveAraligi_m_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_219090_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      KaplamaDurumu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_328449_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      VincKurulumAlani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_4244_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      InverterMontajYeri_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_494854_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KabloYoluGuzergahi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_629508_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_490847_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_668639_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Aciklama3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_91916_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_596085_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KESIF_CATI_KAYDET = result?.data.kesiF_CATI_KAYDET;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_596085_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_596085_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "b6b1ee40_4f43_4419_b601_48f76593b6ce_notify",
        this.defaultML,
        "Kar oranı %20 den düşük olduğu için Proje Yönetici onayına gönderildi"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_596085_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.KESIF_CATI_KAYDET !== undefined
          ? stateVars.KESIF_CATI_KAYDET?.length > 0
            ? stateVars.KESIF_CATI_KAYDET[0].sonuc
            : null
          : this.state.KESIF_CATI_KAYDET?.length > 0
          ? this.state.KESIF_CATI_KAYDET[0].sonuc
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_596085_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.KESIF_CATI_KAYDET !== undefined
            ? stateVars.KESIF_CATI_KAYDET?.length > 0
              ? stateVars.KESIF_CATI_KAYDET[0].onayGerekli
              : null
            : this.state.KESIF_CATI_KAYDET?.length > 0
            ? this.state.KESIF_CATI_KAYDET[0].onayGerekli
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_596085_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_596085_onClick_else1();
      if (isErrorOccurred) return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_442005_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_442005_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OnayDurumuKontrol = result?.data.onayDurumuKontrol;
    stateVars.isComp615511Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp843199Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp658487Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp864664Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp123507Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_442005_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_442005_onActive_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "93ad7140_6f1a_0c7f_6747_429ba471a325_notify",
        this.defaultML,
        "Bu adım bilgilerini girmeniz için ilgili proje için yönetici onayı gerekmektedir."
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_442005_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        "SERBEST"
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_442005_onActive_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_442005_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_442005_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_442005_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_442005_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_442005_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_442005_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_442005_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_442005_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROFORMA_KALEMLERI_GETIR = result?.data.proformA_KALEMLERI_GETIR;

    formVars.catigesonsurecler_751518_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    formVars.catigesonsurecler_968343_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    formVars.catigesonsurecler_575347_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_442005_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_442005_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_899735 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_751518_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_467193 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_968343_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    stateVars.dataSource_594487 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_575347_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_551404_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_858665_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_551404_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_PM_GERI_AL = result?.data.oN_SUREC_PM_GERI_AL;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_551404_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_551404_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "d9482151_7381_0714_ca53_c8c47cd12aad_notify",
        this.defaultML,
        "Proje Onayı Geri Alındı !"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_687126_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_858665_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_687126_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_PM_ONAYLA = result?.data.oN_SUREC_PM_ONAYLA;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_687126_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_687126_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "41233a97_b393_c420_9fc1_e3d5481fc5aa_notify",
        this.defaultML,
        "Proje Başarıyla Onaylandı !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_494735_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_494735_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.OnayDurumuKontrol = result?.data.onayDurumuKontrol;
    stateVars.isComp615511Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp843199Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp658487Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp864664Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp123507Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("SERBEST", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_494735_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_494735_onActive_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "bfb8e566_7703_99a0_22d2_711ae7082a22_notify",
        this.defaultML,
        "Bu adım bilgilerini girmeniz için ilgili proje için yönetici onayı gerekmektedir."
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_494735_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.OnayDurumuKontrol !== undefined
            ? stateVars.OnayDurumuKontrol?.length > 0
              ? stateVars.OnayDurumuKontrol[0].durum
              : null
            : this.state.OnayDurumuKontrol?.length > 0
            ? this.state.OnayDurumuKontrol[0].durum
            : null
        ),
        "SERBEST"
      )
    ) {
      isErrorOccurred =
        await this.CatiGesOnSureclerComponent_494735_onActive_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_494735_onActive2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_494735_onActive2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      TipKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_494735_onActive2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_KESIF_KALEMLER_GETIR = result?.data.oN_KESIF_KALEMLER_GETIR;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_494735_onActive3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_494735_onActive3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.KalemleriDBdenYukle = CWTypeScript.KalemleriDBdenYukle(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string"),
      ReactSystemFunctions.value(this, this.state.ON_KESIF_KALEMLER_GETIR)
    );
    stateVars.KalemleriGetir = CWTypeScript.KalemleriGetir(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetUserByUsername !== undefined
          ? stateVars.GetUserByUsername?.length > 0
            ? stateVars.GetUserByUsername[0].id
            : null
          : this.state.GetUserByUsername?.length > 0
          ? this.state.GetUserByUsername[0].id
          : null
      ),
      this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
      ReactSystemFunctions.convertToTypeByName("NET_KESIF", "string")
    );

    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );
    formVars.catigesonsurecler_505390_value = ReactSystemFunctions.value(
      this,
      stateVars.PROFORMA_GENEL_BILGILERI_GETIR !== undefined
        ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
          ? stateVars.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
          : null
        : this.state.PROFORMA_GENEL_BILGILERI_GETIR?.length > 0
        ? this.state.PROFORMA_GENEL_BILGILERI_GETIR[0].proforma_Tutar
        : null
    );
    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_494735_onActive4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_494735_onActive4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DbName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.AktifSirketGetir !== undefined
            ? stateVars.AktifSirketGetir?.length > 0
              ? stateVars.AktifSirketGetir[0].sirket
              : null
            : this.state.AktifSirketGetir?.length > 0
            ? this.state.AktifSirketGetir[0].sirket
            : null
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GET_ON_SUREC_OZET_GETIR !== undefined
            ? stateVars.GET_ON_SUREC_OZET_GETIR?.length > 0
              ? stateVars.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
              : null
            : this.state.GET_ON_SUREC_OZET_GETIR?.length > 0
            ? this.state.GET_ON_SUREC_OZET_GETIR[0].netsisProjKodu
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_494735_onActive4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PROFORMA_KALEMLERI_GETIR = result?.data.proformA_KALEMLERI_GETIR;

    formVars.catigesonsurecler_751518_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    formVars.catigesonsurecler_968343_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    formVars.catigesonsurecler_575347_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_494735_onActive5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_494735_onActive5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_478263 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_742412_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_899735 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_751518_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    formVars.catigesonsurecler_505390_placeholder =
      ReactSystemFunctions.toString(
        this,
        stateVars.KalemleriGetir !== undefined
          ? stateVars.KalemleriGetir?.length > 0
            ? stateVars.KalemleriGetir[0].genelToplam
            : null
          : this.state.KalemleriGetir?.length > 0
          ? this.state.KalemleriGetir[0].genelToplam
          : null
      );

    stateVars.dataSource_944389 =
      stateVars.KalemleriGetir ?? this.state.KalemleriGetir;
    formVars.catigesonsurecler_806020_value = ReactSystemFunctions.toString(
      this,
      stateVars.KalemleriGetir !== undefined
        ? stateVars.KalemleriGetir?.length > 0
          ? stateVars.KalemleriGetir[0].genelToplam
          : null
        : this.state.KalemleriGetir?.length > 0
        ? this.state.KalemleriGetir[0].genelToplam
        : null
    );

    stateVars.dataSource_467193 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_968343_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    stateVars.dataSource_594487 =
      stateVars.PROFORMA_KALEMLERI_GETIR ?? this.state.PROFORMA_KALEMLERI_GETIR;
    formVars.catigesonsurecler_575347_value = ReactSystemFunctions.toString(
      this,
      stateVars.PROFORMA_KALEMLERI_GETIR !== undefined
        ? stateVars.PROFORMA_KALEMLERI_GETIR?.length > 0
          ? stateVars.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
          : null
        : this.state.PROFORMA_KALEMLERI_GETIR?.length > 0
        ? this.state.PROFORMA_KALEMLERI_GETIR[0].geneltoplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_233488_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_961677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_233488_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_UY_ONAY_GERIAL = result?.data.oN_SUREC_UY_ONAY_GERIAL;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_233488_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_233488_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7fb695ce_501a_1191_efde_41261da9e493_notify",
        this.defaultML,
        "Proje onayı geri alındı !"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  CatiGesOnSureclerComponent_320489_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProjeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProjeID ?? this.props.screenInputs.projeid,
        "number"
      ),
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserByUsername !== undefined
            ? stateVars.GetUserByUsername?.length > 0
              ? stateVars.GetUserByUsername[0].id
              : null
            : this.state.GetUserByUsername?.length > 0
            ? this.state.GetUserByUsername[0].id
            : null
        ),
        "string"
      ),
      OnayNotu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "catigesonsurecler_961677_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "CatiGesOnSurecler/CatiGesOnSureclerComponent_320489_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ON_SUREC_UY_ONAYLA = result?.data.oN_SUREC_UY_ONAYLA;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.CatiGesOnSureclerComponent_320489_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  CatiGesOnSureclerComponent_320489_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7af991ef_3de1_965e_d0f9_b7c3c879d15d_notify",
        this.defaultML,
        "Proje başarıyla onaylandı !"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.CatiGesOnSureclerPageInit();
    }
  }
}
